/*
 * @Author: yeyimei
 * @Date: 2022-11-21 15:29:47
 * @LastEditTime: 2023-06-17 09:33:14
 * @LastEditors: yeyimei
 * @Description:
 * @FilePath: \cardlan-h5-qrcode\src\store\modules\kfc.js
 */
import { setSession, getSession } from "@/libs/storage"
const kfc = {
  state: {
    cartList: getSession("KFC_INFOS")?.cartList || [], //购物车数组
    num: getSession("KFC_INFOS")?.num || 0, //购物车数量
    totalPrice: getSession("KFC_INFOS")?.totalPrice || 0, //总价格
    kfcVipDist: getSession("KFC_INFOS")?.vipDist || 0, //会员优惠价
  },
  mutations: {
    setCartList(state, value) {
      state.cartList = value
      let kfc_infos = getSession("KFC_INFOS") || {}
      kfc_infos.cartList = value
      setSession("KFC_INFOS", kfc_infos)
    },
    setNum(state, value) {
      state.num = value
      let kfc_infos = getSession("KFC_INFOS") || {}
      kfc_infos.num = value
      setSession("KFC_INFOS", kfc_infos)
    },
    setTotalPrice(state, value) {
      state.totalPrice = value
      let kfc_infos = getSession("KFC_INFOS") || {}
      kfc_infos.totalPrice = value
      setSession("KFC_INFOS", kfc_infos)
    },
    setKfcVipDist(state, value) {
      state.kfcVipDist = value
      let mc_infos = getSession("KFC_INFOS") || {}
      mc_infos.vipDist = value
      setSession("KFC_INFOS", mc_infos)
    },
  },
  actions: {},
  getters: {
    cartList: (state) => state.cartList,
  },
}
export default kfc
